import $ from "jquery";
import { CountUp } from "countup.js";

function Counter(el) {
    const elements = $(".counter__digit");

    elements.each(function () {
        const endValue = parseInt($(this).html());
        const countUp = new CountUp(this, endValue, {
            duration: 1.4,
            enableScrollSpy: true,
            scrollSpyOnce: true,
            separator: "",
            decimal: "",
            useEasing: false,
        });

        if (!countUp.error) {
            countUp.start();
        } else {
            console.error(countUp.error);
        }
    });
}

export default Counter;
